export const PAYMENT_METHOD_TYPE = {
  BANK: 'bank',
  CARD: 'card',
  BNPL: 'bnpl'
};
